import React from 'react';
const links = [{
  label: 'Conditions générales',
  href: '#terms'
}, {
  label: 'Politique de confidentialité',
  href: '#privacy'
}, {
  label: 'Politique de remboursement',
  href: '#refund'
}, {
  label: 'Contact et assistance',
  href: '#contact'
}];
export function SiteFooter() {
  return <footer className="border-t border-brand-ivory/10 bg-brand-charcoal px-5 py-12 text-brand-ivory/70 lg:px-8" data-id="element-162" data-mp="3a5khql9kvenb">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-163" data-mp="3f4x4l60g8lpw">
        <div data-id="element-164" data-mp="3k1vufcd2y6ia">
          <p className="font-body text-[13px] font-semibold uppercase tracking-[0.22em] text-brand-ivory" data-id="element-165" data-mp="3k1nhjkgyj173">
            Barber Instructor Ready™
          </p>
          <p className="mt-1 font-body text-[12px] text-brand-ivory/55" data-id="element-166" data-mp="3t4etrmhnq0zs">Édition française · par Prof. Kyra</p>
        </div>
        <nav aria-label="Pied de page" className="flex flex-wrap gap-x-7 gap-y-2 font-body text-[13px]" data-id="element-167" data-mp="1tru7sxvs1w5r">
          {links.map(link => <a key={link.label} href={link.href} className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-ivory hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-ivory/60" data-id="element-168" data-mp="1yryj89htw0p4">
              {link.label}
            </a>)}
        </nav>
      </div>
      <p className="mx-auto mt-8 max-w-6xl font-body text-[12px] leading-relaxed text-brand-ivory/45" data-id="element-169" data-mp="3nvcmh4eqo8n1">
        © 2026 Barber Instructor Ready™ · Prof. Kyra. Produit numérique au format PDF — aucun article
        physique n’est expédié. Il s’agit d’un ensemble de ressources pédagogiques indépendant, qui ne
        constitue ni une licence professionnelle, ni une certification officiellement reconnue. Paiement
        sécurisé — traité dans votre devise locale.
      </p>
    </footer>;
}